module.exports = __webpack_public_path__ + "static/media/brand.dd677c17.webp";